<template>
  <div class="section-wrap" id="oaSkills-modal-template">
    <div class="multi-item-title mt-40">
      <h3 class="section-title ">OA작성능력</h3>
      <div class="check-util">
        <div class="check-wrap"><input type="checkbox" id="chk2" v-model="oaSkillUseYn" true-value="N"
                                       false-value="Y" title="OA작성능력 해당없음 선택"><label for="chk2"><span>해당없음</span></label></div>
        <button type="button" class="btn btn-line-box btn-sm" @click="resetOaSkills">
          <i class="ico ico-refresh"></i>
          입력항목 초기화
        </button>
      </div>
    </div>
    <div class="table-wrap mt-16" v-for="oaSkill in oaSkills" :key="oaSkill.seq">
      <table class="table-body-only">
        <caption>OA작성능력 정보 테이블</caption>
        <colgroup class="pc-cell">
          <col style="width: 160px;"/>
          <col/>
        </colgroup>
        <colgroup class="mo-cell">
          <col style="width: 88px;"/>
          <col/>
        </colgroup>
        <tbody>
        <tr>
          <th scope="row">문서작성<br>(한글/<br class="mo-only">MS-Word)<span class="must">*</span></th>
          <td>
            <div class="input-area mo-size wid400">
              <select title="문서작성 수준 선택" v-model="oaSkill.docSkl" :disabled="isDisabled">
                <option value="">문서작성 수준 선택</option>
                <option v-for="item in docSkillsCode" :key="item.code" :value="item.code">{{ item.name }}</option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">스프레드시트<br>(Excel)<span class="must">*</span></th>
          <td>
            <div class="input-area mo-size wid400">
              <select title="스프레드시트 수준 선택" v-model="oaSkill.shetSkl" :disabled="isDisabled">
                <option value="">스프레드시트 수준 선택</option>
                <option v-for="item in sheetSkillsCode" :key="item.code" :value="item.code">{{ item.name }}</option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">프리젠테이션<br>(PowerPoint)<span class="must">*</span></th>
          <td>
            <div class="input-area mo-size wid400">
              <select title="프레젠테이션 수준 선택" v-model="oaSkill.pptSkl" :disabled="isDisabled">
                <option value="">프레젠테이션 수준 선택</option>
                <option v-for="item in pptSkillsCode" :key="item.code" :value="item.code">{{ item.name }}</option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">인터넷<br>(정보검색/<br class="mo-only">outlook)<span class="must">*</span></th>
          <td>
            <div class="input-area mo-size wid400">
              <select title="인터넷 활용 수준 선택" v-model="oaSkill.interSkl" :disabled="isDisabled">
                <option value="">인터넷 활용 수준 선택</option>
                <option v-for="item in internetSkillsCode" :key="item.code" :value="item.code">{{ item.name }}</option>
              </select>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Axios from 'axios';
import { apiHandler } from './resume-common';

export default ({
  name: 'oaSkills-modal-template',
  props: ['oaskillsModal', 'indbankNo', 'oaSkillsCode'],
  data() {
    return {
      oaSkillUseYn: 'Y',
      oaSkills: [],
      oaSkill: {
        seq: '',
        docSkl: '',
        shetSkl: '',
        pptSkl: '',
        interSkl: '',
      },
      isDisabled: false,
    };
  },
  watch: {
    oaskillsModal: {
      handler() {
        if (this.oaskillsModal && this.indbankNo) {
          this.getOaskills();
          this.getBasic();
        }
      },
      immediate: true,
    },
    oaSkillUseYn: {
      handler(newVal) {
        this.isDisabled = (newVal === 'N');
      },
    },
  },
  computed: {
    // 문서작성 스킬 코드 (JB09004, JB09005, JB09006 제외)
    docSkillsCode() {
      if (!this.oaSkillsCode || !Array.isArray(this.oaSkillsCode)) return [];
      return this.oaSkillsCode.filter(item =>
        !['JB09004', 'JB09005', 'JB09006'].includes(item.code),
      );
    },

    // 스프레드시트 스킬 코드 (JB09003, JB09005, JB09006 제외)
    sheetSkillsCode() {
      if (!this.oaSkillsCode || !Array.isArray(this.oaSkillsCode)) return [];
      return this.oaSkillsCode.filter(item =>
        !['JB09003', 'JB09005', 'JB09006'].includes(item.code),
      );
    },

    // 프리젠테이션 스킬 코드 (JB09003, JB09004, JB09006 제외)
    pptSkillsCode() {
      if (!this.oaSkillsCode || !Array.isArray(this.oaSkillsCode)) return [];
      return this.oaSkillsCode.filter(item =>
        !['JB09003', 'JB09004', 'JB09006'].includes(item.code),
      );
    },

    // 인터넷 스킬 코드 (JB09003, JB09004, JB09005 제외)
    internetSkillsCode() {
      if (!this.oaSkillsCode || !Array.isArray(this.oaSkillsCode)) return [];
      return this.oaSkillsCode.filter(item =>
        !['JB09003', 'JB09004', 'JB09005'].includes(item.code),
      );
    },
  },
  methods: {
    getBasic() {
      Axios.get(`/api/idb/${this.indbankNo}/basic`).then((response) => {
        if (response.data.success === 'R') {
          this.oaSkillUseYn = response.data.data.oaSkillUseYn;
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    getOaskills() {
      Axios.get(`/api/idb/${this.indbankNo}/oaskills`).then((response) => {
        if (response.data.success === 'R') {
          if (response.data.data.length === 0) {
            // 데이터가 없을 때 기본 OA 스킬 객체 생성
            this.oaSkills = [{
              seq: '',
              docSkl: '',
              shetSkl: '',
              pptSkl: '',
              interSkl: '',
            }];
          } else {
            this.oaSkills = response.data.data.map((oaskill) => {
              const newOaSkill = { ...oaskill };
              if (!oaskill.docSkl) newOaSkill.docSkl = '';
              if (!oaskill.shetSkl) newOaSkill.shetSkl = '';
              if (!oaskill.pptSkl) newOaSkill.pptSkl = '';
              if (!oaskill.interSkl) newOaSkill.interSkl = '';
              return newOaSkill;
            });
          }
        }
      }).catch((e) => {
        apiHandler.handleError(e);
      });
    },
    updateOaskills() {
      if (this.vaildCheck() && confirm('저장하시겠습니까?')) {
        Axios.post(`/api/idb/${this.indbankNo}/oaskills`, {
          oaSkillUseYn: this.oaSkillUseYn,
          oaSkills: this.oaSkills,
        }).then((response) => {
          apiHandler.handleSaveSuccess(response, (res) => {
            // 완성도 업데이트 (올바른 경로로 접근)
            if (res.data && res.data.data.completionRate !== undefined) {
              this.$emit('update:CompletionRate', res.data.data.completionRate);
            }
          });
        }).catch((e) => {
          apiHandler.handleError(e);
        });
      }
    },
    vaildCheck() {
      if (this.oaSkillUseYn === 'N') return true;
      return this.oaSkills.every((oaSkill) => {
        if (!oaSkill.docSkl) {
          alert('문서작성 능력 정보를 선택해주세요');
          return false;
        }
        if (!oaSkill.shetSkl) {
          alert('스프레드시트 능력 정보를 선택해주세요.');
          return false;
        }
        if (!oaSkill.pptSkl) {
          alert('프리젠테이션 능력 정보를 선택해주세요.');
          return false;
        }
        if (!oaSkill.interSkl) {
          alert('인터넷 능력 정보를 선택해주세요.');
          return false;
        }
        return true;
      });
    },
    resetOaSkills() {
      const message = '해당화면의 작성 중인 내용이 사라집니다.\n입력하신 내용을 초기화 하시겠습니까?';

      if (confirm(message)) {
        // OA 스킬 데이터 초기화
        this.oaSkills = [{
          seq: '',
          docSkl: '',
          shetSkl: '',
          pptSkl: '',
          interSkl: '',
        }];

        // 해당없음 체크박스 초기화 (기본값: Y - 해당함)
        this.oaSkillUseYn = 'Y';

        // 비활성화 상태 초기화
        this.isDisabled = false;
      }
    },
  },
});
</script>



// WEBPACK FOOTER //
// Oaskills.vue?48d044aa